import React from "react";
import {useContext, useEffect, useState} from "react";
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AppERoutesIndex, GetMenuItems } from "../../route/app-routes";
import { Logout } from "@mui/icons-material";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { App_sesion_token_key, App_store__token, AxiosInstance, DialogType } from "../../utils/constants";
import { CustomLogoApp } from "../logo";
import { BuyerLiveShell } from "../../features/subasta-inversa-live";


const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  '& .MuiListItemButton-root': {
    marginLeft: 6,
    marginRight: 6,
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: 44,
    justifyContent: 'center',
  },
  '& .MuiListItemIcon-root': {
    minWidth: 0,
    marginRight: 0,
    justifyContent: 'center',
  },
  '& .MuiListItemText-root': {
    opacity: 0,
    width: 0,
    overflow: 'hidden',
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 2),
  minHeight: 56,
  ...theme.mixins.toolbar,
}));


const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);


const DrawerCustom = ({goToNavigate,role,onShowcloseSesion,currentPath,drawerOpen})=>    <div>
<List sx={{ py: 1 }}>
 {GetMenuItems(role).map(MenuItem=><MenuItem.element key={MenuItem.key} keyItem={MenuItem.key} currentPath={currentPath} action={(path)=>goToNavigate(path)} icon={MenuItem.icon} label={MenuItem.label} subItems={MenuItem.subItems} drawerOpen={drawerOpen} />)}
</List>
<Divider />
<List>
<ListItem onClick={onShowcloseSesion} key={'salir'} disablePadding>
      <ListItemButton aria-label="Cerrar sesión">
        <ListItemIcon>
          <Logout />
        </ListItemIcon>
        <ListItemText primary={'Cerrar sesión'} />
      </ListItemButton>
    </ListItem>
</List>
</div>



export const AdminTemplate = ()=>{


    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { store:{isLogged,profile}, dispatch } = useContext(AppContext);
    const [isVisbleCerrarSesion,setisVisbleCerrarSesion] = useState(false);
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();


    const onNavigateView = (path)=>{
      navigate(path);
    
    }

    const onCloseSesion = ()=>{
      localStorage.removeItem(App_sesion_token_key);
      localStorage.removeItem(App_store__token);
      window.location.reload();
      navigate(AppERoutesIndex.main,{replace:true,state:[]});

    }

     useEffect(()=>{
    
      if(!localStorage.getItem(App_sesion_token_key)  ){
       
        navigate(AppERoutesIndex.main,{replace:true,state:{}});
       
      }else{
        LoadUserData();
      }
    },[]);

    const LoadUserData = async()=>{

      try{

        let {data:{value}} = await AxiosInstance.get("sesion/obtener-datos-usuario");
       
        if ( Object.keys(value.perfil).length > 0 ){
          dispatch({
            type:ActionTypes.setProfileUsers,
            data: {...value}
           });
          if ( value.firma ){
             navigate(AppERoutesIndex.plataformaBase,{replace:true});
          
          }else{
             navigate(AppERoutesIndex.generarFirma,{replace:true});
          }
        
       } 

      }catch(e){
        console.log(e.message);
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error en los servicios",
              message:"Ha ocurrido un error al tratar de enviar los datos al servidor",
              type:DialogType.peligro,
              isVisible:true
          }
      });

      }
     
     
   
   }

    return (
        <Box sx={{ display: 'flex' }}>
        <CssBaseline />

        <Dialog
        open={isVisbleCerrarSesion}
        >
          <DialogTitle>Cerrar sesión</DialogTitle>
          <DialogContent>
          <DialogContentText  >
              ¿Está seguro de cerrar la sesión?
          </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={e=>setisVisbleCerrarSesion(false)} size='small' variant='text' >
              Cancelar
            </Button>
            <Button onClick={onCloseSesion} size='small' variant='contained' color='primary' >
              Cerrar sesión
            </Button>
          </DialogActions>
        </Dialog>

        <AppBar
         position="fixed" open={open}
         id="app_bar_top"
        >
             <Toolbar sx={{ minHeight: 56, px: { xs: 2, sm: 3 } }}>
          <IconButton
            color="inherit"
            aria-label="Abrir menú de navegación"
            onClick={e=>setOpen(true)}
            edge="start"
            sx={{
              marginRight: 2,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minHeight: 24 }}>
            <CustomLogoApp variant="isotipo" height={28} alt="Acércate" />
            <Typography variant="subtitle1" noWrap component="div" sx={{ fontWeight: 700 }}>
              Acércate
            </Typography>
          </Box>
        </Toolbar>

        </AppBar>
        <Drawer
            variant="permanent"
            open={open}
          >
          <DrawerHeader sx={{ justifyContent: open ? 'space-between' : 'flex-end', px: 2 }}>
          {open && <CustomLogoApp height={36} alt="Acércate" />}
          <IconButton onClick={()=>setOpen(false)} aria-label="Cerrar menú de navegación">
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
           <DrawerCustom drawerOpen={open} currentPath={location.pathname} onShowcloseSesion={()=>setisVisbleCerrarSesion(true)} role={profile?.perfil?.cod} goToNavigate={onNavigateView} />
          </Drawer>
        <Box
          component="main"
          sx={{ flexGrow: 1, p: { xs: 2, sm: 3 }, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
        >
            <DrawerHeader />
          <BuyerLiveShell />
          <Outlet />
         
        </Box>
      </Box>
    )

}
